import axios from 'axios';
import config from '../config';
import { store } from '../store';

const getHeaders = () => {
  const { authToken } = store.getState().user;
  return { authorization: authToken };
};

const base = () => `${config.apiBaseUrl}/max-users/acefone/dial-mis`;

export const getMisV2 = (agentType = 'doctor') =>
  axios
    .get(`${base()}/v2`, {
      params:  { agent_type: agentType },
      headers: getHeaders(),
    })
    .then((r) => r.data);

export const manualRedial = (applicationNos, agentType = 'doctor') =>
  axios
    .post(
      `${config.apiBaseUrl}/max-users/acefone/manual-redial`,
      { application_nos: applicationNos, agent_type: agentType },
      { headers: getHeaders() }
    )
    .then((r) => r.data);
